



















import { Component, Mixins, Watch } from "vue-property-decorator";
import { ITreeCollapsable, ITreeExpandable, ManagementTokenCollaborativeMixin } from "../../../system";
import { FormatTreeSourceSelectableMixin } from "./mixins";
import { IFormatTreeSelectable, instanceOfIFormatTreeSelectable, ICancelSelectFormatTree, instanceOfICancelSelectFormatTree, IEditFormatTree } from ".";
import FormatReferencesTreeSelector from "./FormatReferencesTreeSelector.vue";
import FormatReferenceTreeEditDialog from "./dialogs/FormatReferenceTreeEditDialog.vue";
import { ManagementTokenPublishResult } from "../../../../domain/system";
import { DomainRegistry } from "../../../../domain";

@Component({
  components: {
    selector: FormatReferencesTreeSelector,
    editDialog: FormatReferenceTreeEditDialog,
  }
})
export default class FormatReferencesSelector extends Mixins(FormatTreeSourceSelectableMixin, ManagementTokenCollaborativeMixin) implements ITreeExpandable, ITreeCollapsable, ICancelSelectFormatTree, IEditFormatTree {
  $refs!: {
    selector: FormatReferencesTreeSelector,
    editDialog: FormatReferenceTreeEditDialog,
  };
  
  @Watch("isLoaded")
  onIsLoadedUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      this.$nextTick(() => {
        // 実行するタイミングでselector取得しないと反映されない.(インスタンスが変わってる？)
        if (this.selectDefaultNode(this.getSelector())) {
          this.defaultNodeSelected();
        }
        if (this.$configuration.behavior.format.selector.shouldExpandTreeAutomatically) {
          this.expandTree();
        }
        this.$nextTick(() => {
          this.loadCompleted(this.isShown);
        });
      });
    }
  }

  @Watch("filter")
  onFilterUpdated(): void {
    this.$nextTick(() => {
      if (this.isLoaded && this.$configuration.behavior.format.selector.shouldExpandTreeAutomatically) {
        this.expandTree();
      }
    });
  }

  getSelector(): IFormatTreeSelectable {
    // TODO: このメソッドを使う意味はまったく無いように見える
    // 修正してしまったほうがよいように思うが、読み解けない影響があったらよくないので残している
    const selector = this.$refs.selector;
    return instanceOfIFormatTreeSelectable(selector)
      ? selector
      : null;
  }

  expandTree(): void {
    this.expandSelectorTree(this.$refs.selector);
  }

  collapseTree(): void {
    this.collapseSelectorTree(this.$refs.selector);
  }

  requestTreeNodeSelectStatus(): void {
    const selector = this.$refs.selector;
    if (instanceOfICancelSelectFormatTree(selector)) {
      selector.requestTreeNodeSelectStatus();
    }
  }

  cancelSelectFormatTree(): void {
    if (!this.isLoaded) {
      return;
    }
    const selector = this.$refs.selector;
    if (instanceOfICancelSelectFormatTree(selector)) {
      selector.cancelSelectFormatTree();
    }
  }

  async editFormatTree(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    if (!FormatReferenceTreeEditDialog.instanceOfSource(this.$refs.editDialog)) {
      return;
    }
    if (this.treeSource.managementKey) {
      await this.executeWithManagementTokenControll(this.treeSource.entityName, isForcibly => this.getManagementToken(isForcibly), this.executeEditFormatReferenceTree);
    } else {
      // 個人頻用はチェック無しで編集開始する想定
      await this.executeEditFormatReferenceTree();
    }
  }

  private async getManagementToken(isForcibly: boolean): Promise<ManagementTokenPublishResult> {
    if (!this.treeSource.managementKey) { throw new Error("managementKey is empty!!!"); }
    const repo = DomainRegistry.format.getFormatRepository();
    return repo.getFormatManagementToken(this.treeSource.managementKey, isForcibly);
  }

  private async executeEditFormatReferenceTree(): Promise<void> {
    // TODO: キャンセル時にErrorをthrowして上位で握りつぶしているので修正したほうがよい
    await this.$refs.editDialog.show(this.shouldIgnoreChained);
    await this.loadTree();
  }
}
